import { useMemo } from 'react';
import { useStore } from '@/store';
import { sessionStorageHelper } from '@/utils/localCache';
import { DEVICE_TYPE, PayInfoSource, ROUTER_MAP, SessionStorageKey } from '@/types';
import Toast from '@/components/Toast';
import { useIntl } from 'react-intl';
import { useRouter } from '@/hooks/useRouter';
// 记录路由记录
export function useHeaderJump() {
    const intl = useIntl();
    const { jump } = useRouter();
    const { orderObj, setOrderObj, routerHistory, device } = useStore();

    const routerBackMap = useMemo(() => {
        return {
            [ROUTER_MAP.SEAT]: {
                default: ROUTER_MAP.SCREEN,
            },
            [ROUTER_MAP.ORDER_CONFIRM]: {
                default: device === DEVICE_TYPE.H5 ? ROUTER_MAP.SEAT : ROUTER_MAP.SCREEN,
            },
            [ROUTER_MAP.PAYMENT]: {
                default: orderObj?.payInfo?.payStatus === PayInfoSource.CREATED ? ROUTER_MAP.ORDER_CONFIRM : -1,
            },
            [ROUTER_MAP.PAYMENT_RESULT]: {
                default: ROUTER_MAP.HOME,
            },
        };
    }, [device, orderObj]);


    const goBack = () => {
        const go = () => {
            const backRouter = routerBackMap[location.pathname]?.default ?? -1;
            const historyPreRouter = routerHistory[routerHistory.length - 2];
            if (historyPreRouter === backRouter) {
                jump(-1);
            } else {
                let qurey = {};
                if (backRouter === ROUTER_MAP.SCREEN) {
                    qurey = {
                        filmUniqueId: orderObj.film.filmUniqueId,
                        filmId: orderObj.film.filmId,
                    };
                }
                jump(backRouter, {
                    query: qurey,
                });
            }
        };
        // 选座页返回增加选中座位时显示提示,反之则无
        const isSelectSeat = sessionStorageHelper.get(SessionStorageKey.selectSeatList) || '';
        if (location.pathname === '/seat' && isSelectSeat.length) {
            Toast({
                type: 1,
                content: intl.formatMessage({
                    id: 'iWeb.components.Header.AfterReturningTheSeatYou',
                    defaultMessage: '返回后，您选择的座位将不再保留',
                }),
                confirmText: intl.formatMessage({ id: 'iWeb.components.Header.Leave', defaultMessage: '离开' }),
                cancelText: intl.formatMessage({
                    id: 'iWeb.components.Header.ContinueSeatSelection',
                    defaultMessage: '继续选座',
                }),
                confirm: () => {
                    // 回退后清空信息
                    orderObj.payInfo = {};
                    setOrderObj(orderObj);
                    setTimeout(() => {
                        go();
                    }, 300);
                },
                cancel: () => {
                    return;
                },
            });
        } else {
            go();
        }
    };

    return goBack;
}

